import { createContext, type ReactNode, useContext } from 'react';
import type { TableLimit, TablePagination } from './Table.types';

type TableContextProps = {
  tableLimit?: TableLimit;
  tablePagination?: TablePagination;
};

const TableContext = createContext<TableContextProps | null>(null);

export const TableProvider = (props: { value: TableContextProps } & { children: ReactNode }) => {
  const { value, children } = props;
  return <TableContext.Provider value={value}>{children}</TableContext.Provider>;
};

export const useTableContext = () => {
  const context = useContext(TableContext);
  if (!context) throw new Error('useTableContext must be used within TableContext.Provider');
  return context;
};
